<template>
  <div class="networkgraph">
    <d3-network ref='net' :net-nodes="nodes" :net-links="links" :options="options" @node-click="nodeClick"/>
    <Asset v-for="asset in filteredAssets" :key="asset.id" :asset="asset"/>
  </div>
</template>

<style>
@import url('https://fonts.googleapis.com/css?family=PT+Sans');
.networkgraph .link{
  stroke: rgba(18,120,98,.3);
}
.networkgraph ul.menu {
  list-style: none;
  position: absolute;
  z-index: 100;
  min-width: 20em;
  text-align: left;
}
.networkgraph ul.menu li{
  margin-top: 1em;
  position: relative;
} 
</style>

<script>
import { mapState } from 'vuex'
import D3Network from 'vue-d3-network'
import Asset from '@/components/Asset.vue'
var allNodes = []
var isClicked = false
// var isClicked = true, assetId = '83e84b03-d35c-49bb-80bc-03cb1e1d7821'
export default {
  name: 'dashboard',
  components: {
    D3Network,
    allNodes,
    Asset,
    isClicked
  },
  watch: {
    profile () {
      console.log('profile changed!')
      this.refreshAssets()
    }
  },
  mounted () {
    this.refreshAssets()
  },
  data () {
    return {
      // nodes: this.getNodes1(),
      // links: this.getLinks(),
      nodeSize:20,
      canvas:false

    }
  },
  computed:{
    nodes() {
      const domainIcon = '<svg id="Layer_1" height="512" viewBox="0 0 128 128" width="512" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="m114.99 94.126a1.714 1.714 0 0 0 .315-.547 59.033 59.033 0 0 0 0-59.158 1.714 1.714 0 0 0 -.315-.547 59.5 59.5 0 0 0 -34.526-26.774 1.727 1.727 0 0 0 -.464-.137 58.941 58.941 0 0 0 -32 0 1.76 1.76 0 0 0 -.458.13 59.493 59.493 0 0 0 -34.532 26.781 1.714 1.714 0 0 0 -.315.547 59.033 59.033 0 0 0 0 59.158 1.714 1.714 0 0 0 .315.547 59.494 59.494 0 0 0 34.5 26.772 1.763 1.763 0 0 0 .481.137 58.944 58.944 0 0 0 32.01 0 1.747 1.747 0 0 0 .505-.143 59.5 59.5 0 0 0 34.484-26.766zm-49.24 25.58v-24.956h23.913c-2.6 9.51-6.341 17.412-10.891 23a55.542 55.542 0 0 1 -13.022 1.956zm-16.522-1.958c-4.55-5.586-8.291-13.487-10.891-23h23.913v24.956a55.542 55.542 0 0 1 -13.022-1.956zm-40.934-52h7.706v13.752a1.751 1.751 0 0 0 1.75 1.75h14.315c.464 3.423 1.066 6.77 1.8 10h-18.475a55.363 55.363 0 0 1 -7.096-25.5zm7.1-29h18.472c-.735 3.23-1.337 6.578-1.8 10h-14.316a1.751 1.751 0 0 0 -1.75 1.752v13.75h-7.706a55.363 55.363 0 0 1 7.096-25.5zm46.856-28.454v24.956h-23.913c2.6-9.51 6.341-17.412 10.891-23a55.542 55.542 0 0 1 13.022-1.956zm16.522 1.958c4.55 5.586 8.291 13.487 10.891 23h-23.913v-24.958a55.542 55.542 0 0 1 13.022 1.958zm40.934 52h-7.706v-13.752a1.751 1.751 0 0 0 -1.75-1.75h-14.315c-.464-3.423-1.066-6.77-1.8-10h18.475a55.363 55.363 0 0 1 7.096 25.5zm-7.1 29h-18.472c.735-3.23 1.337-6.578 1.8-10h14.316a1.751 1.751 0 0 0 1.75-1.752v-13.75h7.706a55.363 55.363 0 0 1 -7.096 25.5zm-46.86 0v-10h26.654c-.479 3.431-1.1 6.779-1.862 10zm-46.246-13.502v-27.5h89v27.5zm72.9-31h-26.65v-10h24.791c.759 3.22 1.382 6.569 1.859 10zm-30.153-10v10h-26.647c.479-3.431 1.1-6.779 1.862-10zm-26.647 44.5h26.65v10h-24.791c-.759-3.221-1.382-6.569-1.859-10zm48.856 34.6a74.1 74.1 0 0 0 8.83-21.1h17.189a56.049 56.049 0 0 1 -26.022 21.096zm26.019-82.6h-17.192a74.164 74.164 0 0 0 -8.83-21.1 56.058 56.058 0 0 1 26.019 21.1zm-66.925-21.1a74.148 74.148 0 0 0 -8.83 21.1h-17.192a56.051 56.051 0 0 1 26.019-21.097zm-26.022 82.6h17.189a74.116 74.116 0 0 0 8.829 21.1 56.058 56.058 0 0 1 -26.018-21.1z"/><path d="m45.789 67.188-3.478-10.563h-2.92l-3.499 10.563-3.156-10.563h-2.942l4.681 14.75h2.662l3.714-10.949 3.693 10.949h2.684l4.658-14.75h-2.941z"/><path d="m67.704 71.375h2.683l4.659-14.75h-2.942l-3.155 10.563-3.478-10.563h-2.92l-3.5 10.563-3.155-10.563h-2.942l4.68 14.75h2.663l3.714-10.949z"/><path d="m83.457 71.375 3.713-10.949 3.693 10.949h2.684l4.659-14.75h-2.942l-3.156 10.563-3.478-10.563h-2.92l-3.499 10.563-3.156-10.563h-2.941l4.68 14.75z"/></svg>'
      const hostIcon = '<svg height="512pt" viewBox="0 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m512 150.636719v-150.636719h-512v150.636719h30.023438v30.046875h-30.023438v150.632812h30.023438v30.050782h-30.023438v150.632812h512v-150.636719h-30.023438v-30.046875h30.023438v-150.632812h-30.023438v-30.046875zm-482-120.636719h452v90.636719h-452zm452 452h-452v-90.636719h452zm-30.023438-120.636719h-391.953124v-30.046875h391.953124zm30.023438-60.046875h-452v-90.632812h452zm-30.023438-120.632812h-391.953124v-30.046875h391.953124zm0 0"/><path d="m321.964844 60.316406h130v30h-130zm0 0"/><path d="m321.964844 241h130v30h-130zm0 0"/><path d="m321.964844 421.683594h130v30h-130zm0 0"/><path d="m60.035156 60.316406h30.023438v30h-30.023438zm0 0"/><path d="m120.085938 60.316406h30.023437v30h-30.023437zm0 0"/><path d="m60.035156 241h30.023438v30h-30.023438zm0 0"/><path d="m120.085938 241h30.023437v30h-30.023437zm0 0"/><path d="m60.035156 421.683594h30.023438v30h-30.023438zm0 0"/><path d="m120.085938 421.683594h30.023437v30h-30.023437zm0 0"/></svg>'
      const appIcon = '<svg id="Capa_1" enable-background="new 0 0 482.239 482.239" height="512" viewBox="0 0 482.239 482.239" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m465.016 0h-344.456c-9.52 0-17.223 7.703-17.223 17.223v86.114h-86.114c-9.52 0-17.223 7.703-17.223 17.223v344.456c0 9.52 7.703 17.223 17.223 17.223h344.456c9.52 0 17.223-7.703 17.223-17.223v-86.114h86.114c9.52 0 17.223-7.703 17.223-17.223v-344.456c0-9.52-7.703-17.223-17.223-17.223zm-120.56 447.793h-310.01v-310.01h310.011v310.01zm103.337-103.337h-68.891v-223.896c0-9.52-7.703-17.223-17.223-17.223h-223.896v-68.891h310.011v310.01z"/></svg>'
      const ipIcon = '<svg height="512pt" viewBox="-41 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m367.265625 63.011719c-40.632813-40.632813-94.660156-63.011719-152.125-63.011719-57.46875 0-111.492187 22.378906-152.128906 63.011719-40.632813 40.636719-63.011719 94.664062-63.011719 152.128906 0 50.25 17.703125 99.152344 49.847656 137.699219v.003906c8.179688 9.804688 17.28125 18.933594 27.0625 27.144531l127.609375 127.613281c2.933594 2.933594 6.777344 4.398438 10.621094 4.398438s7.6875-1.464844 10.617187-4.398438l127.613282-127.613281c9.78125-8.210937 18.882812-17.339843 27.058594-27.148437 32.148437-38.546875 49.851562-87.449219 49.851562-137.699219 0-57.464844-22.378906-111.492187-63.015625-152.128906zm-34.660156 295.265625-117.464844 117.464844-117.464844-117.464844c-.320312-.316406-.652343-.625-1-.914063-8.597656-7.167969-16.589843-15.160156-23.761719-23.757812-27.648437-33.15625-42.878906-75.230469-42.878906-118.464844 0-102.066406 83.039063-185.105469 185.105469-185.105469s185.105469 83.039063 185.105469 185.105469c0 43.234375-15.230469 85.304687-42.882813 118.464844-7.167969 8.597656-15.164062 16.589843-23.757812 23.757812-.347657.289063-.679688.597657-1 .914063zm0 0"/><path d="m262.15625 165.875h-53.339844c-8.292968 0-15.019531 6.722656-15.019531 15.015625v92.988281c0 8.296875 6.726563 15.019532 15.019531 15.019532 8.292969 0 15.019532-6.722657 15.019532-15.019532v-31.476562h38.320312c21.101562 0 38.265625-17.164063 38.265625-38.265625 0-21.097657-17.164063-38.261719-38.265625-38.261719zm0 46.492188h-38.320312v-16.457032h38.320312c4.539062 0 8.230469 3.691406 8.230469 8.230469 0 4.535156-3.691407 8.226563-8.230469 8.226563zm0 0"/><path d="m164.386719 165.875c-8.292969 0-15.019531 6.722656-15.019531 15.015625v92.988281c0 8.296875 6.726562 15.019532 15.019531 15.019532s15.019531-6.722657 15.019531-15.019532v-92.988281c0-8.292969-6.726562-15.015625-15.019531-15.015625zm0 0"/></svg>'
      var nodes = []
      for (const i in this.assets) {
        var asset = this.assets[i]
        var node = {}
        node['id']=asset.id
        node['name']=asset.value

        var type = asset.type
        if(type=='domain') {
          node['_color']='black'
          node['svgSym']=domainIcon
        }
        else if(type=='host') {
          node['_color']='black'
          node['svgSym']=hostIcon
        }
        else if(type=='application') {
          node['_color']='black'
          node['svgSym']=appIcon
        }
        else {
          node['_color']='black'
          node['svgSym']=ipIcon
        }

        nodes.push(node)
        allNodes.push(asset.id)
      }
      return nodes
    },
    links() {
      var links = []
      //console.log('links() allNodes = '+allNodes)
      for (const i in this.assets) {
        var asset = this.assets[i]
        var from = asset.id
        var domains = asset.domains
        var hosts = asset.hosts
        var applications = asset.applications
        var ipranges = asset.ipranges

        if(!(domains === undefined)) {
          for(const j in domains) {
            var to = domains[j]
            if(allNodes.includes(to)) {
              var link = {}
              link['sid'] = from
              link['tid'] = to
              links.push(link)
              //console.log('Link from '+from+' to '+to)
            }
            else {
              console.error(from+' has a link to '+to+' which does not exist')
            }   
          }
        }
        
        if(!(hosts === undefined)) {
          for(const j in hosts) {
            var to = hosts[j]
            if(allNodes.includes(to)) {
              var link = {}
              link['sid'] = from
              link['tid'] = to
              links.push(link)
              //console.log('Link from '+from+' to '+to)
            }
            else {
              console.error(from+' has a link to '+to+' which does not exist')
            }   
          }
        }

        
        if(!(applications === undefined)) {
          for(const j in applications) {
            var to = applications[j]
            if(allNodes.includes(to)) {
              var link = {}
              link['sid'] = from
              link['tid'] = to
              links.push(link)
              //console.log('Link from '+from+' to '+to)
            }
            else {
              console.error(from+' has a link to '+to+' which does not exist')
            }            
          }
        }
        
        if(!(ipranges === undefined)) {
          for(const j in ipranges) {
            var to = ipranges[j]
            if(allNodes.includes(to)) {
              var link = {}
              link['sid'] = from
              link['tid'] = to
              links.push(link)
              //console.log('Link from '+from+' to '+to)
            }
            else {
              console.error(from+' has a link to '+to+' which does not exist')
            }   
          }
        }
      }
      return links
     },
    options(){
      return{
        force: 1000,
        size: {
          w: window.innerWidth,
          h: window.innerHeight * 0.8
        },
        nodeSize: this.nodeSize,
        nodeLabels: true,
        linkLabels:true,
        canvas: this.canvas
      }
    },
    filteredAssets() {
      // console.log('filteredAssets() Start isClicked='+isClicked+' this.selectedAsset= '+this.selectedAsset)
      var selectAsset = this.selectedAsset
      if(!isClicked) {
        return null
      }
      var assets = this.assets.filter(asset => {
        if (asset.id == selectAsset) return true
        return false
      })
      return assets
    },   
    ...mapState([
      'debugMode',
      'account',
      'profile',
      'assets',
      'assetsFilter',
      'selectedAsset'
    ])
  },
  methods: {
    refreshAssets () {
      if (!this.profile.id) return
      this.$store.dispatch('loadAssets', {'all': true})
      // console.log('loadAssets:',this.assets)
    },
    nodeClick(event,node){
      // console.log(event,node)
      isClicked = true
      this.$store.dispatch('selectAsset', {
        assetId: node.id
      })
    },
  },  
}
</script>